import { calcValueByType } from './common';
import { calcSummary } from './summaryUtils';

export {
  calcValueByType,
  calcSummary,
};



// WEBPACK FOOTER //
// ./src/views/ReportPreview/utils/index.js